import Modal from "../../../components/Modal";
import Button from "../../../components/Button";

const MaterialPreviewModal = ({ isOpen, closeModal, material }) => {
  if (!material) return null;
  const isImage = material.file_url?.match(/\.(jpeg|jpg|gif|png|webp)$/i) || material.file_type?.includes("image");
  const isVideo = material.file_url?.match(/\.(mp4|webm|ogg)$/i) || material.file_type?.includes("video");

  return (
    <Modal
      title="Preview Material"
      subtitle={material.title || material.file_name || "Material"}
      isopen={isOpen}
      closeModal={closeModal}
      modalContent={
        <div style={{ width: "100%", minHeight: 300, display: "flex", justifyContent: "center", alignItems: "center", background: "#f9fafb", borderRadius: 8, overflow: "hidden" }}>
          {isImage ? (
            <img src={material.file_url} alt={material.title} style={{ maxWidth: "100%", maxHeight: "60vh", objectFit: "contain" }} />
          ) : isVideo ? (
            <video src={material.file_url} controls style={{ width: "100%", maxHeight: "60vh" }} />
          ) : (
            <iframe src={material.file_url} title={material.title || "Document"} width="100%" height="500px" style={{ border: "none", backgroundColor: "white" }} sandbox="allow-scripts allow-popups" />
          )}
        </div>
      }
      modalFooter={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "12px 0" }}>
          <Button buttonName="Close" onClick={closeModal} variant="primaryoutline" color="btnfontprimary" />
          <Button buttonName="Download" onClick={() => window.open(material.file_url, "_blank")} variant="primary" color="btndefault" />
        </div>
      }
    />
  );
};

export default MaterialPreviewModal;
